import { useLang } from '@/app/utils/useLang';
import { getSolarRecommand } from '@/service/solar-calculator';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoCompareProduct from 'eco-design/sections/eco-compare-product';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import EcoSpace from 'eco-design/base/eco-space';

const Comparison: React.FC = () => {
    const { t } = useLang('Comparison');
    const { locale = 'us' } = useRouter();
    const [list, setList] = useState();
    const isEu = ['eu', 'uk', 'de', 'fr', 'es', 'it', 'nl'].includes(locale)

    const specItems = (row: number) => {
        return [...new Array(isEu ? 11 : 13)].map((item, index) => {
            return {
                desc: t(`item${row + 1}_desc${index + 1}`) || t(`item_desc${index + 1}`),
                title: t(`item${row + 1}_title${index + 1}`),
            };
        });
        // .filter((item, index) => index !== 10);
    };

    // 按区域和产品ID组织配置
    const PRODUCT_CONFIG = {
        us: {
            item1: { productId: '15386067730505', variantId: '54691871227977' },
            item2: { productId: '7289136054345', variantId: '41826182496329' },
            item3: { productId: '7394893463625', variantId: '42015827492937' },
        },
        ca: {
            item1: { productId: '15164532916595', variantId: '62060639584627' },
            item2: { productId: '8331157766298', variantId: '51645140926835' },
            item3: { productId: '15047267156339', variantId: '52389663605107' },
        },
        de: {
            item1: { productId: '15783293813117', variantId: '57786046546301' },
            item2: { productId: '14848608960847', variantId: '53707199873359' },
            item3: { productId: '14848608960847', variantId: '53707200004431' },
        },
        fr: {
            item1: { productId: '10314254516571', variantId: '52135684702555' },
            item2: { productId: '9594942095707', variantId: '49526901768539' },
            item3: { productId: '9594942095707', variantId: '49526901866843' },
        },
        uk: {
            item1: { productId: '10401193427283', variantId: '52914740592979' },
            item2: { productId: '9616877420883', variantId: '49833568895315' },
            item3: { productId: '9616877420883', variantId: '49833568993619' },
        },
        es: {
            item1: { productId: '10314256220507', variantId: '52135688307035' },
            item2: { productId: '9594953924955', variantId: '49526969041243' },
            item3: { productId: '9594953924955', variantId: '49526969139547' },
        },
        it: {
            item1: { productId: '15001832292728', variantId: '55434923082104' },
            item2: { productId: '14845588341112', variantId: '54819109208440' },
            item3: { productId: '14845588341112', variantId: '54819109306744' },
        },
        eu: {
            item1: { productId: '10524538962263', variantId: '52667593982295' },
            item2: { productId: '9744704930135', variantId: '49573797495127' },
            item3: { productId: '9744704930135', variantId: '49573797593431' },
        },
        nl: {
            item1: { productId: '10107353727252', variantId: '51925775876372' },
            item2: { productId: '9935710978324', variantId: '51194415120660' },
            item3: { productId: '9935710978324', variantId: '51194415317268' },
        },
    };
    const getProductConfig = (itemName: any) => PRODUCT_CONFIG[locale]?.[itemName] || PRODUCT_CONFIG.us[itemName];

    const getBuyLink = (locale: string, ind: number) => {
        const maps: Record<string, string[]> = {
            us: [
                'https://us.ecoflow.com/products/delta-3-classic-portable-power-station?variant=54691871227977',
                'https://us.ecoflow.com/products/delta-3-plus-portable-power-station',
                'https://us.ecoflow.com/products/delta-3-portable-power-station',
            ],
            ca: [
                'https://ca.ecoflow.com/products/delta-3-classic-portable-power-station?variant=62060639584627',
                'https://ca.ecoflow.com/products/delta-3-plus-portable-power-station',
                'https://ca.ecoflow.com/products/delta-3-portable-power-station',
            ],
            de: [
                "https://de.ecoflow.com/products/delta-3-classic-portable-power-station",
                "https://de.ecoflow.com/products/delta-3-series-portable-power-station?variant=53707199873359",
                "https://de.ecoflow.com/products/delta-3-series-portable-power-station?variant=53707200004431",
            ],
            fr: [
                "https://fr.ecoflow.com/products/delta-3-classic-portable-power-station",
                "https://fr.ecoflow.com/products/delta-3-series-portable-power-station?variant=49526901768539",
                "https://fr.ecoflow.com/products/delta-3-series-portable-power-station?variant=49526901866843",
            ],
            uk: [
                "https://uk.ecoflow.com/products/delta-3-classic-portable-power-station",
                "https://uk.ecoflow.com/products/delta-3-series-portable-power-station?variant=49833568895315",
                "https://uk.ecoflow.com/products/delta-3-series-portable-power-station?variant=49833568993619",
            ],
            es: [
                "https://es.ecoflow.com/products/delta-3-classic-portable-power-station",
                "https://es.ecoflow.com/products/delta-3-series-portable-power-station?variant=49526969041243",
                "https://es.ecoflow.com/products/delta-3-series-portable-power-station?variant=49526969139547",
            ],
            it: [
                "https://it.ecoflow.com/products/delta-3-classic-portable-power-station",
                "https://it.ecoflow.com/products/delta-3-series-portable-power-station?variant=54819109208440",
                "https://it.ecoflow.com/products/delta-3-series-portable-power-station?variant=54819109306744",
            ],
            eu: [
                "https://eu.ecoflow.com/products/delta-3-classic-portable-power-station",
                "https://eu.ecoflow.com/products/delta-3-series-portable-power-station?variant=49573797495127",
                "https://eu.ecoflow.com/products/delta-3-series-portable-power-station?variant=49573797593431",
            ],
            nl: [
                "https://nl.ecoflow.com/products/delta-3-classic-portable-power-station",
                "https://nl.ecoflow.com/products/delta-3-series-portable-power-station?variant=51194415120660",
                "https://nl.ecoflow.com/products/delta-3-series-portable-power-station?variant=51194415317268",
            ],

        };
        return maps[locale][ind] || '';
    };
    let items = [
        {
            subItems: [
                {
                    title: t('item1_title'),
                    desc: t('item1_desc'),
                    lChildren: t('item1_btn'),
                    lHref: getBuyLink(locale, 0),
                    lDataLayer: {
                        event: 'uaEvent',
                        event_name: 'checkout',
                        button_name: `${t('item1_btn')}`,
                    },
                    rChildren: t('item_more') || '',
                    rHref: isEu ? getBuyLink(locale, 0) : `https://${locale}.ecoflow.com/products/delta-3-classic-portable-power-station`,
                    rDataLayer: {
                        event: 'uaEvent',
                        event_name: 'buy',
                        position: t('link_more'),
                    },
                    productId: getProductConfig('item1').productId,
                    variantId: getProductConfig('item1').variantId,
                    specItems: specItems(0),
                },
            ],
        },
        {
            subItems: [
                {
                    title: t('item2_title'),
                    desc: t('item2_desc'),
                    lChildren: t('item2_btn'),
                    lHref: getBuyLink(locale, 1),
                    lDataLayer: {
                        event: 'uaEvent',
                        event_name: 'checkout',
                        button_name: `${t('item2_btn')}`,
                    },
                    rChildren: t('item_more'),
                    rHref: isEu ? getBuyLink(locale, 1) : `https://${locale}.ecoflow.com/products/delta-3-plus-portable-power-station`,
                    productId: getProductConfig('item2').productId,
                    variantId: getProductConfig('item2').variantId,
                    specItems: specItems(1),
                },
            ],
        },
        {
            subItems: [
                {
                    title: t('item3_title'),
                    desc: t('item3_desc'),
                    lChildren: t('item3_btn'),
                    lHref: getBuyLink(locale, 2),
                    lDataLayer: {
                        event: 'uaEvent',
                        event_name: 'checkout',
                        title_name: t('item3_title'),
                        button_name: t('item3_btn'),
                    },
                    rChildren: t('item_more'),
                    rHref: isEu ? getBuyLink(locale, 2) : `https://${locale}.ecoflow.com/products/delta-3-portable-power-station`,
                    productId: getProductConfig('item3').productId,
                    variantId: getProductConfig('item3').variantId,
                    specItems: specItems(2),
                },
            ],
        },
    ];

    const getAsynItem = async (productId: string, variantId: string) => {
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    return resolve(res);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    useEffect(() => {
        const promises = items?.map((item: any) => getAsynItem(item?.subItems[0].productId, item.subItems[0].variantId));
        Promise.all(promises).then((res) => {
            const old = JSON.parse(JSON.stringify(items));
            const list = res.map((i: any, idx) => {
                // const notSaleList = [2]; // 配置非开售产品 index
                const variantId = getProductConfig(`item${idx + 1}`).variantId;
                if (i.data.variantImg) {
                    old[idx].subItems[0].pc = i.data.variantImg;
                }

                // if (i.data.inventoryQuantity === 0 && !notSaleList.includes(idx)) {
                //     old[idx].subItems[0].lChildren = t(`item${idx + 1}_sold`);
                //     old[idx].subItems[0].lDisabled = true;
                // }
                if (isEu) {
                    old[idx].subItems[0].title = (i.data.skuTitle === 'Default Title' || !!i.data.skuTitle) ? i.data.productTitle : i.data.skuTitle;
                }

                // old[idx].subItems[0].lDataLayer.button_name = `${old[idx].subItems[0].lDataLayer.button_name}_${i.data.skuTitle}`;
                // old[idx].subItems[0].lHref = notSaleList.includes(idx)
                //     ? `https://${locale}.ecoflow.com/products/delta-3-classic-portable-power-station?variant=${variantId}`
                //     : `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;

                if (old[idx]?.subItems?.[0]) {
                    old[idx].subItems[0].lHref = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                }

                return old[idx];
            });
            items = JSON.parse(JSON.stringify(list));
            setList(list as any);
        });
    }, []);

    return (
        <div className={`page-comparison range7 ${styles.Comparison} GtmModuleData-section`} data-section-id="d3c-Comparison" id="Compare">
            <EcoSectionCommon title={t('title')} />
            {list && <EcoCompareProduct items={list}></EcoCompareProduct>}
            <EcoSpace />
        </div>
    );
};

export default Comparison;
